import { List as AntdList, ListProps } from 'antd';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import type { Props as InfiniteProps } from 'react-infinite-scroll-component';
import styled from '@emotion/styled';
export type Props = {
  id?: string;
  dataSource?: any[];
  renderItem: (item: any, index: number) => React.ReactNode;
  height: string | number;
  loadMoreData?: () => any;
  loader?: React.ReactNode;
  hasMore?: boolean;
  isLoading?: boolean;
  isLazy?: boolean;
  listProps?: ListProps<any>;
  infiniteProps?: Partial<InfiniteProps> | undefined;
};
const ContainerList = styled.div`
  overflow: auto;
  padding: 0 16px;
  .ant-list-items {
    max-height: 250px;
  }
`;
export const List = ({
  hasMore,
  loader,
  renderItem,
  height,
  listProps,
  infiniteProps,
  dataSource = [],
  loadMoreData = () => {},
  isLazy = false,
  ...props
}: Props) => {
  if (isLazy) {
    return (
      <div {...props}>
        <InfiniteScroll
          height={height || 400}
          scrollThreshold={1}
          hasChildren
          hasMore={!!hasMore}
          dataLength={dataSource.length}
          loader={loader}
          next={loadMoreData}
          {...infiniteProps}
        >
          <AntdList
            dataSource={dataSource}
            renderItem={renderItem}
            {...listProps}
          ></AntdList>
        </InfiniteScroll>
      </div>
    );
  }
  return (
    <ContainerList
      style={{
        height
      }}
      {...props}
    >
      <AntdList
        dataSource={dataSource}
        renderItem={renderItem}
        {...listProps}
      ></AntdList>
    </ContainerList>
  );
};

List.Item = AntdList.Item;

export default List;
export * from './ListItem';
